import { Card, FormGroup, FormParagraph, SectionHeader } from '@ksyos/design-system';
import type { IAdminProcess, IServiceActivity } from '@common/interfaces';
import { NullableFormattedDatetime } from '@frontend/components/elements/NullableFormattedDatetime';
import { PractitionerAndOrganization } from '@frontend/components/pages/processes/newAdminProcessDetails/PractitionerAndOrganization';

type ActivitiesSectionProps = {
    process: IAdminProcess;
    serviceActivities: IServiceActivity[];
};

export function ActivitiesSection({ process, serviceActivities }: ActivitiesSectionProps) {
    if (process.activities.length === 0) {
        return null;
    }

    return (
        <>
            <SectionHeader title="Activiteiten" />
            {process.activities.map((processActivity) => {
                const serviceActivity = serviceActivities.find(
                    (activity) => activity.id === processActivity.serviceActivity.id
                );
                if (serviceActivity) {
                    return (
                        <Card key={processActivity.id}>
                            <Card.Header title={serviceActivity.name} />
                            <Card.Body>
                                <FormGroup label="Status">
                                    <FormParagraph>{processActivity.status}</FormParagraph>
                                </FormGroup>
                                <FormGroup label="Uitgevoerd op">
                                    <FormParagraph>
                                        <NullableFormattedDatetime value={processActivity.performedDatetime} />
                                    </FormParagraph>
                                </FormGroup>
                                <PractitionerAndOrganization
                                    externalName={processActivity.externalPerformerName}
                                    label="Uitgevoerd door"
                                    organization={processActivity.performerOrganization}
                                    practitioner={processActivity.performerPractitioner}
                                />
                            </Card.Body>
                        </Card>
                    );
                }

                return null;
            })}
        </>
    );
}
